module.exports = __webpack_public_path__ + "static/img/slsBanner.8f28de2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slsBanner.png
// module id = UJJc
// module chunks = 2